
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compress-pdf",
      function () {
        return require("private-next-pages/compress-pdf.js");
      }
    ]);
  